import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import './ImageModal.css';

const ImageModal = ({ isOpen, onClose, imageUrl, title }) => {
    // Handle escape key press
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            // Prevent background scrolling
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="image-modal-overlay" onClick={onClose}>
            <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="image-modal-header">
                    <h3 className="image-modal-title">{title}</h3>
                    <button
                        className="image-modal-close"
                        onClick={onClose}
                        aria-label="Close modal"
                    >
                        <X size={24} />
                    </button>
                </div>

                <div className="image-modal-body">
                    <img
                        src={imageUrl}
                        alt={title}
                        className="image-modal-image"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            // Show error message
                            const errorMsg = document.createElement('div');
                            errorMsg.textContent = 'Failed to load image';
                            errorMsg.className = 'image-error';
                            e.target.parentNode.appendChild(errorMsg);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ImageModal;